import {Box} from '@chakra-ui/react';
import {useInView} from 'framer-motion';
import {useRef} from 'react';

interface SlideInBoxProps {
  children: React.ReactNode;
}

export const SlideInBox: React.FC<SlideInBoxProps> = ({
  children,
}: SlideInBoxProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true});

  return (
    <Box overflow="hidden" ref={ref}>
      <Box
        transform={isInView ? 'translateY(0)' : 'translateY(calc(100% + 32px))'}
        transition="all .7s ease"
        transitionDelay="150ms"
      >
        {children}
      </Box>
    </Box>
  );
};
